module.exports = __webpack_public_path__ + "img/primary_3x3_z18.72dc8e6d.svg";